import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import { login, register, selectUserError, clearError } from "../../store/user/user";
import styles from "./AuthPortal.module.css";
import chessLogo from "../../assets/chesslogo.png";

function AuthPortal() {
  const dispatch = useAppDispatch();
  const authError = useAppSelector(selectUserError);

  const [isLoginTab, setIsLoginTab] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");

  // Clear errors when switching tabs
  useEffect(() => {
    dispatch(clearError());
    setFormError("");
    setUsername("");
    setPassword("");
  }, [isLoginTab, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError("");

    if (!username.trim() || !password.trim()) {
      setFormError("Semua field wajib diisi.");
      return;
    }

    if (username.length < 3) {
      setFormError("Username minimal 3 karakter.");
      return;
    }

    if (password.length < 4) {
      setFormError("Password minimal 4 karakter.");
      return;
    }

    if (isLoginTab) {
      dispatch(login({ username, password }));
    } else {
      dispatch(register({ username, password }));
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.glassCard}>
        <div className={styles.logoWrapper}>
          <img src={chessLogo} alt="Chess Logo" className={styles.logoImage} />
          <h1 className={styles.title}>Crimson Chess AI</h1>
          <p className={styles.subtitle}>Tantang AI Tertangguh & Pantau Progress Anda</p>
        </div>

        <div className={styles.tabContainer}>
          <button
            type="button"
            className={`${styles.tabButton} ${isLoginTab ? styles.activeTab : ""}`}
            onClick={() => setIsLoginTab(true)}
          >
            Masuk
          </button>
          <button
            type="button"
            className={`${styles.tabButton} ${!isLoginTab ? styles.activeTab : ""}`}
            onClick={() => setIsLoginTab(false)}
          >
            Daftar
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.authForm}>
          {(authError || formError) && (
            <div className={styles.errorAlert}>
              <span className={styles.errorIcon}>⚠️</span>
              <p className={styles.errorText}>{authError || formError}</p>
            </div>
          )}

          <div className={styles.inputGroup}>
            <label htmlFor="username" className={styles.label}>
              Username
            </label>
            <input
              id="username"
              type="text"
              className={styles.input}
              placeholder="Masukkan username..."
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="off"
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <input
              id="password"
              type="password"
              className={styles.input}
              placeholder="Masukkan password..."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className={styles.submitButton}>
            {isLoginTab ? "Masuk Sekarang" : "Buat Akun"}
          </button>
        </form>
        
        <div className={styles.footerNote}>
          <p>
            {isLoginTab
              ? "Belum punya akun? Silakan klik tab Daftar."
              : "Sudah terdaftar? Silakan klik tab Masuk."}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuthPortal;
